import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdministrationResultStatus, DailyAvailabilityArgs, PaginationArgs, RetrieveGeneratedTimeSlotsData, TermData, UserProfileData } from 'src/app/clients/system-api/SystemApiClient';
import { CalendarRefreshService } from 'src/app/services/calendar.service';
import { EmployeeService } from 'src/app/services/employee.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import { ServiceService } from 'src/app/services/service.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { TermService } from 'src/app/services/term.service';
import * as moment from 'moment';
import { GenericModalComponent } from 'src/app/components/modals/generic-modal/generic-modal.component';

@Component({
  selector: 'app-term-edit-popup',
  templateUrl: './term-edit-popup.component.html',
  styleUrls: ['./term-edit-popup.component.scss'],
})
export class TermEditPopupComponent implements OnInit {
  termData = new Array<TermData>();
  originalTermData = new Array<TermData>();
  employeeData: UserProfileData[] | undefined = [];

  dailyAvailabilityArgs: DailyAvailabilityArgs = new DailyAvailabilityArgs();
  termHourlyData: any[] | undefined = [];
  hourSelection: Date = new Date()
  yesterday = new Date();

  cancelTermActive: boolean = false;
  confirmCancel: boolean = false;
  serviceName!: string;
  totalMinutesArray = new Array<number>();
  cancleTermPopupState?: boolean;

  @Input() arg?: any;
  @Input() termId?: number;
  @Input() mergeFromDate?: Date;
  @Input() mergeToDate?: Date;

  @Output() close = new EventEmitter<boolean>();

  @ViewChild(GenericModalComponent) genericModalComponent!: GenericModalComponent;

  constructor(public serviceService: ServiceService,
    public employeeService: EmployeeService,
    public scheduleService: ScheduleService,
    public termService: TermService,
    private _snackBarService: SnackBarService,
    private calendarRefreshService: CalendarRefreshService,
    private router: Router) {
    this.yesterday.setDate(this.yesterday.getDate() - 0)
  }

  ngOnInit(): void {
    var paginationArgs = new PaginationArgs();
    paginationArgs.skipCount = 0;
    paginationArgs.maxResultCount = 9999;
    paginationArgs.sorting = 'Id ASC';

    this.termService.retrieveAllTerms(paginationArgs).subscribe((data) => {
      var items = data.content!.items!.filter(x =>
        x.cancelled == false &&
        x.fromDate! >= this.mergeFromDate! &&
        x.toDate! <= this.mergeToDate!)

      this.originalTermData = items;
      items.forEach((term) => {
        this.termData.push(new TermData(term))
      });

      items.forEach((term) => {
        this.totalMinutesArray.push(this.calculateTotalMinutesDifference(term))
      });

    });

    this.employeeService.retrieveAllUsers(3).subscribe((data) => {
      this.employeeData = data.content?.items;
    });
  }

  calculateTotalMinutesDifference(term: TermData): number {
    const startTime = term.fromDate!.getTime();
    const endTime = term.toDate!.getTime();

    const timeDifference = endTime - startTime;
    const totalMinutes = Math.floor(timeDifference / (1000 * 60));

    return totalMinutes;
  }

  editTerm(index: number) {
    if (this.termData[index] !== undefined && this.termData[index].fromDate !== undefined) {
      var fromDate = this.termData[index].fromDate;
      fromDate?.setHours(this.hourSelection.getHours());
      fromDate?.setMinutes(this.hourSelection.getMinutes());
      this.termData[index].fromDate = moment(fromDate).utc(true).toDate();

      this.termService.editTerm(this.termData[index]).subscribe((data) => {
        this._snackBarService.callSnackBar(data, "Successfully entered");
        if (data == AdministrationResultStatus.Success) {
          this.calendarRefreshService.triggerRefresh();
          this.closePopup();
        } else {
          this._snackBarService.callSnackBar("Error", "error");
        }
      });
    }
  }

  resetDateTime(index: number) {
    this.termData[index].fromDate = undefined;
    this.hourSelection = new Date();
  }

  retriveHours(index: number) {
    if (this.termData[index] !== undefined) {
      var term = this.termData[index]
      if (term.fromDate) {
        var date = moment(term.fromDate).utc(true).toDate();

        var body = new DailyAvailabilityArgs({
          employeeProfileId: term.employeeProfileId, serviceId: term.serviceId,
          hourlyAvailabilityCheck: true, hourlyAvailabilityCheckLimit: undefined,
          startDate: date, endDate: date
        });

        this.scheduleService.retrieveAvailability(body).subscribe((data: any) => {
          const formattedDate = this.formatDatePickerDate(date!);

          this.termHourlyData = new Array<Date>()
          this.termHourlyData = data.content[formattedDate]?.hourlyAvailability;
        });
      }
    }
  }

  public toggleCancelTermDayPopup(state?: boolean, termId?: number, serviceName?: string) {
    this.cancleTermPopupState = false;
    this.cancleTermPopupState = state ?? !this.cancleTermPopupState;
    this.termId = termId;
    this.serviceName = serviceName!;
  }

  closePopup() { this.close.emit(); }

  formatDatePickerDate(date: Date): string {
    let formattedDate = moment(date).utc(true);
    formattedDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

    return formattedDate.format('YYYY-MM-DDTHH:mm:ss') + "Z";;
  }

  cancelTerm() {
    this.termService.cancelTerm(this.termId).subscribe((data) => {
      this._snackBarService.callSnackBar(data, "Successfully canceled");
      if (data == AdministrationResultStatus.Success) {
        this.closePopup();
      } {
        this._snackBarService.callSnackBar("Error", "error");
      }
    });
  }
}
